export default {
  notFound: '/404',
  serverError: '/500',
  donation: {
    root: '/',
    BASKET_CREATION: '/',
    DONOR_INFORMATION: '/donate/donor-information',
    PAYMENT: '/donate/payment',
    THANKS: '/donate/thanks',
    FAILED: '/donate/failed',
    PROFILE: '/profile',
    RESET_PASSWORD: '/reset-password'
  }
};
